const LightBlue = {
  LightBlue: {
    _100: '#E0F2FE',
    _500: '#0EA5E9',
  },
};

export default LightBlue;
